import React, { useEffect, useState } from "react";
import { useTranslation, Trans } from "react-i18next";
import { useHistory } from "react-router-dom";
import axios, { CancelToken } from "axios";

import { StatusCode } from "api/protocols";

import { showError } from "redux/actions/ui";
import { useAppDispatch } from "hooks/redux";
import Page from "components/page/Page";
import DataTable from "../../../../../components/dataTable/DataTable";
import { GetKitchenMeals, IKitchenMeal } from "api/rpc/2024-04/facilityAdmin/facility/kitchen/meals";

export interface IKitchenCourse {
  id: number;
  facility_id: number;
  position: number;
  title: string;
}

export default function KitchenCourse() {
  const history = useHistory();
  const { t, i18n } = useTranslation();

  const dispatch = useAppDispatch();

  const [kitchenMeals, setKitchenMeals] = useState<IKitchenMeal[]>(undefined);

  useEffect(() => {
    const source = axios.CancelToken.source();
    void getCourses(source.token);
    return () => source.cancel();
  }, []);

  async function getCourses(token?: CancelToken) {
    if (kitchenMeals !== undefined) {
      setKitchenMeals(undefined);
    }
    const res = await GetKitchenMeals(null, token ? false : true, token);
    if (token && token.reason) {
      return;
    }

    if (res?.status !== StatusCode.OK) {
      dispatch(showError(t("Error getting courses")));
    }

    setKitchenMeals(res.status !== StatusCode.OK ? [] : res.data);
  }

  const primaryAction = {
    content: t("New Menu Group"),
    action: () => history.push("/admin/settings/courses/new"),
  };

  return (
    <Page title={t("Menu Groups")} narrow primaryAction={primaryAction} subtitle={t("Define how items are grouped in a customer order (e.g., Appetizers, Mains).")}>
      <DataTable
        columns={[{ label: t("Title") }]}
        loading={kitchenMeals === undefined}
      >
        {kitchenMeals?.map(course => {
          return (
            <tr
              key={course.id}
              className="clickable"
              onClick={() => history.push("/admin/settings/courses/" + String(course?.id))}
            >
              <td>{course?.title}</td>
            </tr>
          );
        })}
      </DataTable>
    </Page>
  );
}
